module.exports = "../../../../platform/assets/pageMainIcon/industry_yewushezhilei6.svg";